import { noop } from 'lodash-es'

import { BenefitGroup } from '../../../models/benefit/Benefit'
import { EssentialsContentSection, EssentialsUpcomingEventData } from '../../essentials/types'

export interface GetHealthChallengesToolkitPagePropsParams {
  onExploreCareOptionsPress?: () => void
  onPressSearchForCare?: () => void
  onFooterLinkPress?: (url: string) => void
  isUserInternational?: boolean
  legalNotice?: React.ReactNode
  userDisplayLanguage?: string
  eventsList?: EssentialsUpcomingEventData[]
  eventsLoading?: boolean
  onPressUpcomingEssentialsEventsHeaderLink?: () => void
  onPressUpcomingEssentialsEventsCard?: (eventSlug: string) => void
  isEssentialsEnabled?: boolean
  isLibraryEventsDisabled?: boolean
  recommendedBenefitGroupsForUser?: BenefitGroup[]
  allBenefitGroupsForUser?: BenefitGroup[]
  onPressIntegratedBenefit?: (eventProps: {
    benefitClicked: string
    categoryOfClickedBenefit: string
    benefitUrl: string
  }) => void
  onPressShowAllBenefits?: () => void
  onIntegratedBenefitsExplorerLoad?: () => void
  essentialsSections?: EssentialsContentSection[]
  onEssentialsSeeMorePress?: () => void
}

export interface HealthChallengesToolkitPageProps {
  commonSectionProps: {
    onExploreCareOptionsPress: () => void
  }
  essentialsSectionProps?: {
    essentialsSections?: EssentialsContentSection[]
    onEssentialsSeeMorePress?: () => void
  }
  eventsSectionProps: {
    userDisplayLanguage?: string
    upcomingEvents?: EssentialsUpcomingEventData[]
    eventsLoading?: boolean
    onPressUpcomingEssentialsEventsHeaderLink?: () => void
    onPressUpcomingEssentialsEventsCard?: (eventSlug: string) => void
    isEssentialsEnabled?: boolean
    isLibraryEventsDisabled?: boolean
  }
  relatedBenefitsSectionProps: {
    recommendedBenefitGroupsForUser?: BenefitGroup[]
    allBenefitGroupsForUser?: BenefitGroup[]
    onPressIntegratedBenefit?: (eventProps: {
      benefitClicked: string
      categoryOfClickedBenefit: string
      benefitUrl: string
    }) => void
    onPressShowAllBenefits?: () => void
    onIntegratedBenefitsExplorerLoad?: () => void
  }
  footerSectionProps: {
    onPressSearchForCare: () => void
  }
  legalSectionProps: {
    footerLinkPressed: (url: string) => void
    isUserInternational: boolean
    legalNotice?: React.ReactNode
  }
}

export const getHealthChallengesToolkitPageProps = ({
  onExploreCareOptionsPress = noop,
  onPressSearchForCare = noop,
  onFooterLinkPress = noop,
  isUserInternational = false,
  legalNotice,
  userDisplayLanguage,
  eventsList,
  eventsLoading,
  onPressUpcomingEssentialsEventsHeaderLink,
  onPressUpcomingEssentialsEventsCard,
  isEssentialsEnabled,
  isLibraryEventsDisabled,
  recommendedBenefitGroupsForUser,
  allBenefitGroupsForUser,
  onPressIntegratedBenefit,
  onPressShowAllBenefits,
  onIntegratedBenefitsExplorerLoad,
  essentialsSections,
  onEssentialsSeeMorePress,
}: GetHealthChallengesToolkitPagePropsParams): HealthChallengesToolkitPageProps => {
  return {
    commonSectionProps: {
      onExploreCareOptionsPress,
    },
    essentialsSectionProps: {
      essentialsSections,
      onEssentialsSeeMorePress,
    },
    eventsSectionProps: {
      userDisplayLanguage,
      upcomingEvents: eventsList,
      eventsLoading,
      onPressUpcomingEssentialsEventsHeaderLink,
      onPressUpcomingEssentialsEventsCard,
      isEssentialsEnabled,
      isLibraryEventsDisabled,
    },
    relatedBenefitsSectionProps: {
      recommendedBenefitGroupsForUser,
      allBenefitGroupsForUser,
      onPressIntegratedBenefit,
      onPressShowAllBenefits,
      onIntegratedBenefitsExplorerLoad,
    },
    footerSectionProps: {
      onPressSearchForCare,
    },
    legalSectionProps: {
      footerLinkPressed: onFooterLinkPress,
      isUserInternational,
      legalNotice,
    },
  }
}
